"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

export const RelationLink = ({
    relationTo,
    id,
    label,
}: {
    relationTo: string | null;
    id: string | null;
    label: string | null;
}) => {
    const pathName = usePathname();

    if (!relationTo || !id || !label) {
        return <span style={{ color: "red" }}>Link missing info</span>;
    }

    const isInRoot = pathName === "/";
    const classes = "hover:cursor-pointer hover:text-blue-400 transition-colors";
    let link = "";
    switch (relationTo) {
        case "characters":
            link = isInRoot ? `?character=${id}` : `/character/${id}`;
            return (
                <Link className={classes} href={link}>
                    {label}
                </Link>
            );
        case "groups":
            link = isInRoot ? `?group=${id}` : `/group/${id}`;
            return (
                <Link className={classes} href={link}>
                    {label}
                </Link>
            );
        case "consumerMedia":
            link = isInRoot ? `?media=${id}` : `/media/${id}`;
            return (
                <Link className={classes} href={link}>
                    {label}
                </Link>
            );
        case "codex":
            link = isInRoot ? `?codex=${id}` : `/codex/${id}`;
            return (
                <Link className={classes} href={link}>
                    {label}
                </Link>
            );
        default:
            return <span>{label}</span>;
    }
};

export default RelationLink;
